const checkAccess = (userStore, allowedRoles = [2, 3, 4]) => {
  // New boolean-flag path — preferred.
  if (userStore?.isGlobalAdmin) return allowedRoles.includes(4)
  if (userStore?.isScopedAdmin) return allowedRoles.includes(3)
  if (userStore?.isConfigurationEditor) return allowedRoles.includes(2)
  if (userStore?.isReportReader) return allowedRoles.includes(1)
  // Legacy numeric-role path.
  const role = typeof userStore === 'number' ? userStore : userStore?.role
  return allowedRoles.includes(role)
}

export default checkAccess
